export default __webpack_public_path__ + "static/media/recording.f1371b8f.jpg";